module.exports = __webpack_public_path__ + "static/media/Integrity-Seguros-Logo.ac7757fa.jpg";